<template>
  <div class="dash-meeting-agenda__list-item">
    <router-link :to="link" class="dash-meeting-agenda__link">
      <div class="grid">
        <div class="grid__col--1 dash-meeting-agenda__icon h-center-align"><i class="fa fa-calendar-day meeting-agenda__link-icon"></i></div>
        <div class="grid__col--2 dash-meeting-agenda__date h-center-align">{{ agenda.meeting_date }}</div>
        <div class="grid__col--9 dash-meeting-agenda__name">{{ agenda.title }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'MeetingAgenda',
    props: {
      agenda: {
        type: Object,
      },
    },
    computed: {
      link() {
        return `meeting-agendas/view/${this.agenda.id}`;
      },
    },
  };
</script>

